import React from 'react'
import clsx from 'clsx'
import { addYears, subYears, isSameYear, format, startOfDecade } from 'date-fns'

import type { CalendarProps } from './Calendar'

export interface YearCalendarProps extends Pick<CalendarProps, 'value'> {
  displayDate: Date
  onChange: (value: Date) => void
}

const YearCalendar: React.FC<YearCalendarProps> = ({
  value,
  displayDate,
  onChange,
}: YearCalendarProps): JSX.Element => {
  const base = 'calendar'
  const calendarSize = 3 * 4
  const startYear = subYears(startOfDecade(displayDate), 1)

  const years: Date[] = Array(calendarSize)
    .fill(startYear)
    .map((date, incrementor) => addYears(date, incrementor))

  const itemCn = (year: Date) =>
    clsx(
      `${base}__calendar-item`,
      `${base}__calendar-item--month`,
      value && isSameYear(value, year) && `${base}__calendar-item--selected`,
      isEdge(year) && `${base}__calendar-item--edge`,
    )

  const isEdge = (year: Date): boolean => {
    const first = years[0]
    const last = years[years.length - 1]

    return year === first || year === last
  }

  return (
    <div
      className={`${base}__calendar-body--month`}
      data-testid='calendar-container-year'
    >
      {years.map((_year, index) => (
        <div
          key={index}
          className={itemCn(_year)}
          onClick={() => onChange(_year)}
          data-testid={`calendar-year-${format(_year, 'yyyy')}`}
        >
          {format(_year, 'yyyy')}
        </div>
      ))}
    </div>
  )
}

export default YearCalendar
